import { motion } from 'framer-motion'
import Albums from '../Data/albums'
import AlbumCard from '../Components/Music/AlbumCard'
import styles from './Music.module.css'

const Music = () => {
  return (
    <motion.div
      layoutId='music-tile' // 🔥 MUST match Homepage
      className={styles.layout}
      style={{ width: '100%', height: '100%' }}
      transition={{
        delay: 0.3,
        duration: 0.7,
        ease: [0.77, 0, 0.175, 1], // cinematic ease
      }}
    >
      <motion.h1
        className={styles.pageTitle}
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
      >
        Music
      </motion.h1>

      <motion.div
        className={styles.albums}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3 }}
      >
        {Albums.map((album, index) => (
          <AlbumCard
            key={index}
            album={album}
          />
        ))}
      </motion.div>
    </motion.div>
  )
}

export default Music
